import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Table } from '@quintoandar-tokko/jopijs';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';
import { getPerformanceConversionRateTable } from '@/store/slices/components/dashboard/service';
import ConversionRateTableRow from './ConversionRateTableRow';
import buildQuery from '../../utils/buildQuery';
import buildTableQuery from '../../utils/buildTableQuery';
import useObserver from '@/hooks/useObserver';

export default function ConversionRateNonGroupedTableContent({ headers }) {
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const dispatch = useDispatch();
  const { conversionRate } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const { ref: loadMoreRef, isInViewport } = useObserver();

  useEffect(() => {
    if (!conversionRate.has_next) return;
    if (!isInViewport || conversionRate.loading) return;

    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(conversionRate, {
      withNextPage: true,
    });

    dispatch(getPerformanceConversionRateTable({ query, tableQuery }));
  }, [isInViewport]);

  return (
    <Table.Rows>
      {conversionRate.list.map((row, index) => (
        // eslint-disable-next-line
        <ConversionRateTableRow key={index} row={row} />
      ))}

      <Box as="tr" ref={loadMoreRef} style={{ height: 1, opacity: 0 }} />

      {(conversionRate.loading || conversionRate.has_next) && (
        <LoadingMoreSkeleton columns={headers.length} />
      )}
    </Table.Rows>
  );
}
